import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=322b30d2&scoped=true"
import script from "./AccountManage.vue?vue&type=script&lang=js"
export * from "./AccountManage.vue?vue&type=script&lang=js"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=322b30d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b30d2",
  null
  
)

export default component.exports